






































































































import {Component, Prop, Inject, Vue} from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import {TippyComponent} from 'vue-tippy';

@Component({
    components: {
        Draggable,
        tippy: TippyComponent,
    },
})
export default class FlexGridSettingsEditDialogColumnsList extends Vue {
    @Inject('onColumnChange') readonly onColumnChange!: Function;
    @Inject() moduleName!: string;
    @Prop() items!: any;

    get editingToShowOnlyVisibleColumns(): boolean {
        return this.$store.state[this.moduleName].editingToShowOnlyVisibleColumns;
    }

    beforeCreate() {
        (this
            .$options as any).components.subList = require('./FlexGridDisplaySettingsEditDialogColumnsList.vue').default;
    }

    onGroupChange(item: any) {
        if (!item.Groupable) return;
        item.Group = !item.Group;
        this.onColumnChange(item);
    }

    onVisibleChange(item: any) {
        item.Visible = !item.Visible;
        if (!item.Key) {
            this.changeColumnsVisibility(item.Columns, item.Visible);
        }
    }

    onEditChange(item: any) {
        item._edit = true;
        this.$nextTick().then(() => {
            const input = this.$el.getElementsByClassName('edit-input')[0];
            if (input && input instanceof HTMLInputElement) input.select();
        });
    }

    onBlur(item: any) {
        item._edit = false;
        if (typeof item.CustomCaption != 'string' || !item.CustomCaption.trim()) item.CustomCaption = null;
        if (item.Group) this.onColumnChange(item);
    }

    onCustomCaptionReset(item: any) {
        item._edit = false;
        item.CustomCaption = null;
    }

    onColumnDelete(item: any) {
        if (this.editingToShowOnlyVisibleColumns && item.Key) {
            item.Visible = false;
        } else {
            const index = this.items.findIndex((temp: any) => temp === item);
            if (index != -1) {
                this.changeColumnsVisibility(item.Columns, false);
                this.items.splice(index, 1, ...item.Columns);
            }
        }
    }

    changeColumnsVisibility(items: any, bool = false) {
        const callback = (item: any) => {
            item.Visible = bool;
            if (item.Columns) item.Columns.forEach(callback);
        };

        items.forEach(callback);
    }

    onChange(event: any) {
        if (this.editingToShowOnlyVisibleColumns && (event.moved || event.added)) {
            let newIndex = event.moved ? event.moved.newIndex : event.added.newIndex;

            let itemsReversedSlice = this.items.slice(0, newIndex).reverse();
            let gap = 0;

            for (let i = 0; i < itemsReversedSlice.length; i++) {
                let current = itemsReversedSlice[i];
                if (current.Visible) break;
                else gap += 1;
            }

            let newIndexWithGap = newIndex - gap;
            let [element] = this.items.splice(newIndex, 1);
            this.items.splice(newIndexWithGap, 0, element);
        }
    }
}
